import { render, staticRenderFns } from "./Curatorship.vue?vue&type=template&id=38280d6e&scoped=true"
import script from "./Curatorship.vue?vue&type=script&lang=js"
export * from "./Curatorship.vue?vue&type=script&lang=js"
import style0 from "./Curatorship.vue?vue&type=style&index=0&id=38280d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38280d6e",
  null
  
)

export default component.exports